<template>
  <v-flex
    v-if="!loading"
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('import adoptions')"
        :to="{ name: routeName.ADOPTION_IMPORT }"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("IMPORT") }}
      </v-btn>
      <v-btn
        v-if="can('create adoptions')"
        @click="showAdoptionModal(0)"
        color="primary"
        dark
        class="ml-2 mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.editor_name="{ item }">
        <router-link :to="{ name: routeName.EDITOR_SHOW, params: { id: item.editor.id } }">
            {{ item.editor.name }}
        </router-link>
      </template>
      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex>
                <v-btn
                  icon
                  color="red"
                  @click="deleteAdoption(item.adoption.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchAdoptions"
    />
  </div>
  </v-flex>
  <Loader v-else/>
</template>
<script>

  import { mapActions } from 'vuex';

  import { adoptionsService } from '../../utils/services/adoptions.service';
  import Search from '../../components/shared/Inputs/Search';
  import Loader from '../../components/shared/Loader';
  import AdoptionModal from '../../components/modals/Adoptions/AdoptionModal.vue';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'AdoptionList',
    components: { Search, Loader, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          { text: this.$t('fields.isbn'), value: 'book.isbn' },
          { text: this.$t('fields.title'), value: 'book.title' },
          { text: this.$t('fields.author'), value: 'book.author' },
          { text: this.$t('fields.volume'), value: 'book.volume' },
          { text: this.$t('fields.editor'), value: 'editor_name' },
          { text: this.$t('fields.class'), value: 'adoption.class' },
          { text: this.$t('fields.section'), value: 'adoption.section' },
          { text: this.$t('fields.is_new'), value: 'adoption.is_new' },
          { text: this.$t('fields.is_suggested'), value: 'adoption.is_suggested' },
          { text: this.$t('fields.adoption_year'), value: 'adoption.adoption_year' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          search: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showAdoptionModal(id) {
        this.showModal({
          component: AdoptionModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('ADOPTION'),
            onSave: (
              form,
              error,
            ) => adoptionsService.store(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchAdoptions(this.pagination.page);
            }),
          },
        });
      },

      async fetchAdoptions(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async deleteAdoption(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return adoptionsService.remove(id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchAdoptions(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchAdoptions(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchAdoptions(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchAdoptions(1);
          }
        },
      },

    },
  };
</script>
